import { render, staticRenderFns } from "./BottomOptionFilter2.vue?vue&type=template&id=6522dbb1&scoped=true&"
import script from "./BottomOptionFilter2.vue?vue&type=script&lang=js&"
export * from "./BottomOptionFilter2.vue?vue&type=script&lang=js&"
import style0 from "./BottomOptionFilter2.vue?vue&type=style&index=0&id=6522dbb1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6522dbb1",
  null
  
)

export default component.exports